import styled from "styled-components";
import { Drawer } from "antd";

export const Container = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px 0px 10px 0px;
  }

  .ant-drawer-title strong {
    font-family: "Asap", sans-serif;
    font-size: 16px;
    color: #591f74;
  }
`;

export const Body = styled.div`
  width: 100%;
  padding: 0px 24px;
  min-height: -moz-calc(100vh - 165px);
  min-height: -webkit-calc(100vh - 165px);
  min-height: calc(100vh - 165px);

  .empty {
    color: #9074bf;
  }
`;

export const HeaderFields = styled.div`
  width: 100%;
  margin-bottom: 16px;

  .ant-row-flex {
    margin-bottom: 6px;
  }

  span.label {
    font-family: "Asap", sans-serif;
    font-size: 13px;
    color: #8a50a5;
    font-weight: bold;
    margin-right: 6px;
  }

  span.value {
    font-family: "Asap", sans-serif;
    font-size: 14px;
    color: #4b4b4b;
  }
`;

export const BatchCard = styled.div`
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 12px;
  background: #fff;

  .batchHeader {
    margin-bottom: 8px;

    strong {
      font-family: "Asap", sans-serif;
      font-size: 15px;
      color: #4b4b4b;
    }
  }

  .batchDate {
    font-family: "Asap", sans-serif;
    font-size: 13px;
    color: #9074bf;
  }

  .batchObservation {
    margin-top: 8px;
    font-family: "Asap", sans-serif;
    font-size: 13px;
    color: #4b4b4b;
  }

  .empty {
    color: #b0b0b0;
  }

  .ant-table-thead > tr > th {
    background: transparent;
    font-size: 11px;
    text-transform: uppercase;
    color: #8a50a5;
  }
`;

export const Footer = styled.div`
  border-top: 1px solid #e8e8e8;
  margin-top: 20px;
  width: 100%;
  padding: 10px 24px;
  border-radius: 0 0 4px 4px;

  .buttonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button:first-of-type {
      margin-right: 12px !important;
    }
  }
`;
